import * as Yup from 'yup';

export const updateAssignedAgentFormValidationSchema = (isRequired: boolean) => Yup.object({
  assignee: isRequired
    ? Yup.object({
      id: Yup.number().required('Il campo è obbligatorio'),
      email: Yup.object().required('Il campo è obbligatorio'),
    }).required('Il campo è obbligatorio')
    : Yup.object().nullable(),
});
